import {
    Field,
    FormikProps
} from 'formik';
import {
    FormikRadioCardGroup,
    PlatformFieldset
} from "@flexinet/ui-components";
import {
    AccountApplicationFormType,
    AccountApplicationStatus
} from "../types.ts";
import {ApplicationsAutocomplete} from "../../applications/inputs/ApplicationsAutocomplete.tsx";


export const FormComponent = (props: FormikProps<AccountApplicationFormType>) => {

    const editing = typeof props.values.id !== 'undefined';

    return (
        <>
            <PlatformFieldset legend={'Account Application Details'}>

                <Field
                    name='applicationId'
                    label='Application'
                    description='Please select application'
                    component={ApplicationsAutocomplete}
                    disabled={editing}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>


            <PlatformFieldset legend={'Status'}>

                <Field
                    name='accountApplicationStatus'
                    data={[{
                        label: AccountApplicationStatus.ACTIVE,
                        value: AccountApplicationStatus.ACTIVE
                    }, {
                        label: AccountApplicationStatus.INACTIVE,
                        value: AccountApplicationStatus.INACTIVE
                    }]}
                    component={FormikRadioCardGroup}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>
        </>
    );
};
